import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DEFAULT_TITLE = "Amass Pros Private Limited";
const DEFAULT_DESC =
  "An Innovative Startup Initiative Registered Under The Patent Act, 1970. Women Empowering Communities Through Structured Self-Employment.";
const SITE_URL = "https://amasspros.com";

const seoByPath = {
  "/": {
    title: "Amass Pros Private Limited | Structured Self-Employment",
    description: DEFAULT_DESC,
  },
  "/about": {
    title: "About Us | Amass Pros Private Limited",
    description:
      "Learn about Amass Pros Private Limited, our mission, values, and long-term vision for ethical structured self-employment.",
  },
  "/our-role": {
    title: "Our Role | Amass Pros Private Limited",
    description:
      "Understand our role in empowering communities through transparent systems, registered shopping centres, and sustainable opportunities.",
  },
  "/our-invention": {
    title: "Innovation | Amass Pros Private Limited",
    description:
      "Explore the innovation framework and strategic model developed by Amass Pros Private Limited for long-term value creation.",
  },
  "/shopping-centre": {
    title: "Shopping | Amass Pros Private Limited",
    description:
      "Know how Registered Shopping Centres support customers and structured self-employment opportunities in the Amass Pros model.",
  },
  "/contact": {
    title: "Contact Us | Amass Pros Private Limited",
    description:
      "Contact Amass Pros Private Limited for support, information, and assistance regarding our services and opportunities.",
  },
};

export default function RouteSeo() {
  const { pathname } = useLocation();
  const seo = seoByPath[pathname] || {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESC,
  };

  useEffect(() => {
    document.title = seo.title;

    const descTag = document.querySelector('meta[name="description"]');
    if (descTag) {
      descTag.setAttribute("content", seo.description);
    }

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute("href", `${SITE_URL}${pathname}`);
    }
  }, [pathname, seo.description, seo.title]);

  return null;
}
